import { render, staticRenderFns } from "./CampProgram.vue?vue&type=template&id=023f4539&scoped=true&"
import script from "./CampProgram.vue?vue&type=script&lang=js&"
export * from "./CampProgram.vue?vue&type=script&lang=js&"
import style0 from "./CampProgram.vue?vue&type=style&index=0&id=023f4539&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f4539",
  null
  
)

export default component.exports